import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { t } from '@lingui/macro';
import Input from '@components/form/Input2';
import Label from '@components/form/Label';
import { LiveEventQuery } from '@gql/generated';
import IconTooltip from '@components/IconTooltip';
import FormGroup from '@components/form/FormGroup';

const FlexiblePriceLabel = styled(Label)`
  ${Input.toString()} {
    margin-top: 8px;
  }
`;

const FlexiblePriceInfo = styled.span`
  display: flex;
  align-items: center;
  font-size: 12px;
  opacity: 0.8;
  margin-top: 5px;

  span {
    margin-left: 5px;
  }
`;

type Props = {
  inputName: string;
  flexiblePrice: number;
  currency: string;
  flexibleMinAmountCents: number;
  flexibleMaxAmountCents: number;
};

export const EventFlexiblePaymentAmount = (props: Props) => {
  const {
    flexiblePrice,
    currency,
    flexibleMinAmountCents,
    flexibleMaxAmountCents,
    inputName,
  } = props;

  let invalidValue = false;
  if (flexiblePrice * 1 === flexiblePrice) {
    //
    if (
      flexiblePrice < flexibleMinAmountCents / 100 ||
      flexiblePrice > flexibleMaxAmountCents / 100
    ) {
      invalidValue = true;
    }
  }

  return (
    <FlexiblePriceLabel>
      <Trans
        id="live.payment_page.flexible_price.input_label"
        message="Enter the amount you wish to pay"
      />
      <FormGroup
        data-testid="BuyGiftForm__recipientEmail--group"
        errorMsg={
          invalidValue
            ? t({
                id: 'validation.number_min_max',
                values: {
                  min: flexibleMinAmountCents / 100,
                  max: flexibleMaxAmountCents / 100,
                },
              })
            : null
        }
      >
        <Input
          type="number"
          name={inputName ?? 'flexiblePrice'}
          value={String(flexiblePrice)}
          min={flexibleMinAmountCents}
          max={flexibleMaxAmountCents}
        />
        {!invalidValue ? (
          <FlexiblePriceInfo>
            <Trans
              id="live.payment_page.flexible_price.input_description"
              values={{
                min_amount: flexibleMinAmountCents / 100 + ' ' + currency,
                max_amount: flexibleMaxAmountCents / 100 + ' ' + currency,
              }}
            />
            <IconTooltip
              translationId={t`live.payment_page.flexible_price.input_tooltip`}
            />
          </FlexiblePriceInfo>
        ) : null}
      </FormGroup>
    </FlexiblePriceLabel>
  );
};
